import React from 'react';
import './heroheadline.scss';

export default function HeroHeadlineText({ headlineText }) {
  return (
    <div className="hero-headline-wrapper">
      <h2 className="hero-headline-text">{headlineText}</h2>
    </div>
  );
}
